
import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FlatButton extends Vue {
  @Prop({ type: Boolean })
  readonly sm!: boolean;

  @Prop({ type: Boolean })
  readonly lg!: boolean;

  @Prop({ type: Boolean })
  readonly gradient!: boolean;

  @Prop({ type: Boolean })
  readonly textLg!: boolean;

  get classes() {
    const { root, flat, gradient, sm, lg, 'text-lg': textLg } = this.$style;

    return [
      root,
      {
        [flat]: !this.gradient,
        [gradient]: this.gradient,
        [sm]: this.sm,
        [lg]: this.lg,
        [textLg]: this.textLg,
      },
    ];
  }

  render(createElement: CreateElement): VNode {
    const tag = this.$attrs.href ? 'a' : 'button';

    const { default: defaultSlot } = this.$slots;

    return createElement(
      tag,
      {
        class: this.classes,
        attrs: this.$attrs,
        on: this.$listeners,
      },
      defaultSlot
    );
  }
}
